import Axios from "../redux/setupAxios";
import { microserviceNames } from "../app/utils/constants";

const proxyName = microserviceNames.authentication;

export async function login(body) {
  return (await Axios.post(`${proxyName}/login`, body)).data;
}

export async function signup(
  body,
  stakeholderToken,
  tokenResponse,
  idTokenResponse
) {
  return (
    await Axios.post(`${proxyName}/signup`, body, {
      headers: {
        asanToken: tokenResponse,
        stakeholderToken: stakeholderToken,
        idToken: idTokenResponse,
      },
    })
  ).data;
}

export async function generateTokenFromData(body) {
  return (await Axios.post(`${proxyName}/generateTokenFromData`, body)).data;
}

// export async function checkObject(voen, objectCodes) {
//     return (await Axios.post(`${proxyName}/checkObjects`, { voen, objectCodes })).data;
// };

export async function getObject(voen) {
  return (await Axios.get(`${proxyName}/getObjects?voen=${voen}`)).data;
}

export async function getDigitalLoginToken(body) {
  return (await Axios.post(`${proxyName}/oauth2/token`, body)).data;
}

export async function getDigitalLoginCertificates(token) {
  return (
    await Axios.get(`${proxyName}/oauth2-resources/certificates`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    })
  ).data;
}

export async function getDigitalLoginSessions(token) {
  return (
    await Axios.get(`${proxyName}/oauth2-resources/sessions`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    })
  ).data;
}